import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const CALENDLY_URL = 'https://calendly.com/tools-webridgeai/30min';

export default function ContactSection() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section id="contact" data-testid="contact-section" className="py-24 lg:py-32 relative">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <span className="text-xs uppercase tracking-[0.2em] text-[#00E5FF] font-semibold block mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Book a Demo
          </span>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-white mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            Ready to bridge the gap?
          </h2>
          <p className="text-base text-neutral-400" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Tell us about your business and we'll build a custom AI voice agent for you.
          </p>
        </motion.div>

        {/* Calendly Embed */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="bg-neutral-900/40 border border-white/5 rounded-2xl p-4 lg:p-6 overflow-hidden"
          data-testid="calendly-embed-wrapper"
        >
          <div
            className="calendly-inline-widget"
            data-url={`${CALENDLY_URL}?hide_gdpr_banner=1&background_color=111111&text_color=f0f2f5&primary_color=00E5FF`}
            style={{ minWidth: '280px', height: '660px', width: '100%' }}
            data-testid="calendly-inline-widget"
          />
        </motion.div>
      </div>
    </section>
  );
}
